import React, { Fragment } from 'react';

import PickupOrder from '../../../models/PickupOrder';

import style from './ordersDriver.module.css';

interface DriverPickupFromDeliverToProps {
  order: PickupOrder;
};

const driverPickupFromDeliverTo = (props: DriverPickupFromDeliverToProps) => {

  const { order } = props;
  const contact: JSX.Element[] = order.forwarder_company_info.contacts.map( (contact, index) => {
    return (
      <div key={ index }>{ contact }</div>
    )
  });

  return (
    <Fragment>         
      <div className={ style.forwarderContact }>
        <div>

          <div className={ style.pot }>Forwarder </div>
          <div className={ style.pot }>contact: </div>
        </div>
        <div>
          <div className={ style.pod }>{ order.fwd_user_name } </div>
          <div className={ style.pod }>{ contact }</div>
        </div>
        
      </div>
 
      <div className={ [style.pot, style.wrapper].join(' ') }>Order Details</div>
    
      <div className={ [style.horizontalLineNoMargin, style.wrapper].join(' ') }></div>

      <div className={ [style.flex, style.formsWrapper].join(' ') }>

        <div className={ style.width50 }>

          <div className={ [style.pot, style.wrapper].join(' ') }>Pick Up From:</div>
          <div className={ [style.pickupDeliverBoxText, style.wrapper].join(' ') }>{ order.pickup_from? order.pickup_from.full_address : ''}</div>
        
        </div>

        <div className={ style.width50 }>

          <div className={[style.pot, style.wrapper].join(' ') }>Deliver To:</div>
          <div className={ [style.pickupDeliverBoxText, style.wrapper].join(' ') }>{ order.deliver_to ? order.deliver_to.full_address : '' }</div>
        
        </div>
      
      </div>
    </Fragment>
  );
}

export default driverPickupFromDeliverTo;